import { AUTHENTICATED_HOME_PATH } from '../../../shared/routes.js';

const AUTH_RETURN_PARAM = 'auth_return';

export function getRedirectTarget(search: string): string {
  const params = new URLSearchParams(search);
  const redirectTarget = params.get('redirect');

  if (!redirectTarget || redirectTarget === '/') {
    return AUTHENTICATED_HOME_PATH;
  }

  return redirectTarget;
}

function isProtectedAppPath(pathname: string): boolean {
  return pathname === '/projects' || pathname.startsWith('/projects/') || pathname.startsWith('/settings');
}

export function buildAuthReturnRedirectTarget(redirectTo: string): string {
  const target = new URL(redirectTo, 'https://anysync.local');

  if (!isProtectedAppPath(target.pathname)) {
    return redirectTo;
  }

  if (!target.searchParams.has(AUTH_RETURN_PARAM)) {
    target.searchParams.set(AUTH_RETURN_PARAM, '1');
  }

  return `${target.pathname}${target.search}${target.hash}`;
}

export function buildEmailVerificationCallbackUrl(
  origin: string,
  redirectTo: string,
  email: string,
): string {
  const params = new URLSearchParams();
  params.set('verified', '1');
  params.set('redirect', redirectTo);
  if (email) {
    params.set('email', email);
  }
  return `${origin}/login?${params.toString()}`;
}

export type EmailVerificationNotice = {
  tone: 'success' | 'warning';
  message: string;
};

export function getEmailVerificationNotice(search: string): EmailVerificationNotice | null {
  const params = new URLSearchParams(search);

  if (params.get('verified') === '1') {
    return {
      tone: 'success',
      message: 'Email confirmed. Sign in to continue.',
    };
  }

  switch (params.get('error')) {
    case 'token_expired':
      return {
        tone: 'warning',
        message: 'That verification link expired. Request a new email to continue.',
      };
    case 'invalid_token':
      return {
        tone: 'warning',
        message: 'That verification link is invalid. Request a new email to continue.',
      };
    case 'user_not_found':
      return {
        tone: 'warning',
        message: 'We could not find that account. Create a new one or request another email.',
      };
    default:
      return null;
  }
}

export function isEmailNotVerifiedError(message: string): boolean {
  return /email not verified/i.test(message);
}
